module.exports = __webpack_public_path__ + "static/media/2.c3df1fc9.png";